import { createMunicipioApi } from "@/contexts/cadastro/municipio/api/municipioApi";
import { useAuth } from "react-oidc-context";

export const useMunicipio = () => {
  const { user } = useAuth();
  const municipioApi = createMunicipioApi(user?.access_token);

  const getMunicipiosMt = municipioApi.listAll;

  return { getMunicipiosMt };
};
